import * as React from "react";
import { forwardRef } from "react";
const SvgMoreOptions = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 3, height: 16, viewBox: "0 0 3 16", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M0 14.5A1.5 1.5 0 1 1 1.5 16 1.5 1.5 0 0 1 0 14.5M0 8a1.5 1.5 0 1 1 1.5 1.5A1.5 1.5 0 0 1 0 8m0-6.5A1.5 1.5 0 1 1 1.5 3 1.5 1.5 0 0 1 0 1.5", "data-name": "Union 135" }));
const ForwardRef = forwardRef(SvgMoreOptions);
export { ForwardRef as ReactComponent };
